const axios = require('axios');

document.addEventListener("DOMContentLoaded", () => {
	const favoritesButtons = document.querySelectorAll(".favorites-button");
	favoritesButtons.forEach(element => {
		const { id } = element.dataset;
		element.addEventListener('click', () => {
			axios.post(`/api/favorites/${id}/`)
				.then(element.classList.toggle('active'))
				.catch();
		})
	})
})
